module.exports = __webpack_public_path__ + "img/icon_2.7c5ca961.png";